/*
 * Dolfi - Fix ricerca SKU parziale (wildcard).
 * In italiano (lingua primaria) la ricerca Shopify matcha lo SKU solo ESATTO;
 * nelle lingue secondarie il prefisso funziona in automatico. Aggiungendo '*'
 * all'ultimo termine della query, il prefisso funziona anche in italiano
 * (es. 19401 -> 19401*). Non distruttivo, solo lato tema. Indagine 2026-06-30.
 * NB: si applica SOLO all'input ricerca prodotti (name="q"), non al filtro Paese.
 * Caricato NON-defer (vedi search-modal.liquid) per registrare il listener
 * prima dei moduli del tema e vincere la capture su Enter.
 */
(function () {
  'use strict';

  function withWildcard(value) {
    var t = (value || '').trim();
    if (!t) return t;
    if (t.charAt(t.length - 1) === '*') return t;
    return t + '*';
  }

  function isProductSearchInput(el) {
    return el instanceof HTMLInputElement && el.name === 'q';
  }

  // 1) Enter sull'input ricerca prodotti: aggiunge '*' PRIMA che il componente legga il valore.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var el = event.target;
    if (!isProductSearchInput(el)) return;
    if (!el.value || !el.value.trim()) return;
    el.value = withWildcard(el.value);
  }, true);

  // 2) Submit di un form di ricerca (GET /search): garantisce '*' sul campo q.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value && input.value.trim()) {
      input.value = withWildcard(input.value);
    }
  }, true);

  // 3) Estetica: nella pagina risultati toglie il '*' dalla vista (box, messaggio no-results, titolo tab).
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q || q.charAt(q.length - 1) !== '*') return;
    var clean = q.replace(/\*+$/, '');

    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      var v = (i.value || '').trim();
      if (v.charAt(v.length - 1) === '*') i.value = v.replace(/\*+$/, '');
    });

    document.querySelectorAll('.search-results__no-results').forEach(function (node) {
      if (node.textContent && node.textContent.indexOf(q) !== -1) {
        node.textContent = node.textContent.split(q).join(clean);
      }
    });

    if (document.title && document.title.indexOf(q) !== -1) {
      document.title = document.title.split(q).join(clean);
    }
  });
})();
